export class AdvisorPortalConfigurationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAdvisorPortalConfigurations() {
    return this.#http.get('/api/advisor-portal-configurations');
  }

  async getAdvisorPortalConfiguration({ id }) {
    return this.#http.get(`/api/advisor-portal-configurations/${id}`);
  }

  async createAdvisorPortalConfiguration(body) {
    return this.#http.post('/api/advisor-portal-configurations', body);
  }

  async updateAdvisorPortalConfiguration({ id, ...body }) {
    return this.#http.put(`/api/advisor-portal-configurations/${id}`, body);
  }

  async deleteAdvisorPortalConfiguration({ id }) {
    return this.#http.delete(`/api/advisor-portal-configurations/${id}`);
  }

  async getAdvisorPortalConfigurationDomains({ id }) {
    return this.#http.get(`/api/advisor-portal-configurations/${id}/domains`);
  }

  async assignAdvisorPortalConfigurationDomain({ id, domainName }) {
    return this.#http.post(`/api/advisor-portal-configurations/${id}/domains`, { domainName });
  }

  async removeAdvisorPortalConfigurationDomain({ id, domainName }) {
    return this.#http.delete(`/api/advisor-portal-configurations/${id}/domains/${domainName}`);
  }

  async uploadAdvisorPortalConfigurationImage({ id, type, formData }) {
    return this.#http.post(`/api/advisor-portal-configurations/${id}/images/${type}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}
